import { formatNumberBR, unformatNumberBR } from 'src/utils'

export const formatNumber = (event) => {
  const element = event.target

  if (!element) {
    return
  }

  const validatedValue = unformatNumberBR(element.value.replace(/[^0-9]/g, ""))
  const v = (parseInt(validatedValue, 10) / 1000)

  if (Number.isNaN(v)) {
    element.value = formatNumberBR((0).toFixed(3))
    return
  }

  element.value = formatNumberBR(v, 3)
}
